/** @jsx jsx */
import React, { type ComponentType, type PropsWithChildren, type Ref, forwardRef } from 'react';
import { css, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import type { RouteLinkItemProps } from '@atlassian/jira-navigation-types/src/types.tsx';

const MenuItemCss = css({
	position: 'relative',
});

const StretchedBlanketCss = css({
	position: 'absolute',
	width: '100%',
	height: '100%',
	top: token('space.0'),
	left: token('space.0'),
	outlineOffset: token('space.negative.025'),

	'&:focus, &:active, &:focus-visible': {
		outlineOffset: token('space.negative.025'),
	},
});

// This blank space is needed to enforce React Router to render the empty anchor tag
const BLANKET_CONTENT = ' ';

type InteractiveElement = HTMLButtonElement | HTMLAnchorElement;

export const WithUnwrappedInteractiveChildren = (
	InteractiveBlanket: ComponentType<
		Required<PropsWithChildren<unknown>> & {
			ref?: Ref<InteractiveElement>;
			css?: ReturnType<typeof css>;
		}
	>,
) =>
	forwardRef<InteractiveElement, RouteLinkItemProps>(({ children, className, ...props }, ref) => (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
		<span css={MenuItemCss} className={className}>
			<InteractiveBlanket css={StretchedBlanketCss} ref={ref} {...props}>
				{BLANKET_CONTENT}
			</InteractiveBlanket>
			{children}
		</span>
	));
